export default {
  scratch_beginner: {
    //using downslash because it is an id
    id: 'scratch_beginner',
    name: 'Scratch Game Design Beginner',
    minAge: 7,
    maxAge: 10,
    skillLevel: 'Beginner - Intermediate',
    description:
      'Designed for new coders ages 7-10. Students will be introduced to the fundamental coding concepts through game design.',
    capacity: 7,
    courseType: 'youth'
  },
  scratch_advanced: {
    id: 'scratch_advanced',
    name: 'Scratch Game Design Advanced',
    minAge: 10,
    maxAge: 12,
    skillLevel: 'Intermediate - Advanced',
    description:
      'This course is designed for students who have some experience coding. Students will practice their coding skills and learn further coding concepts through game design. Students will use MIT’s Scratch coding platform to create a variety of animations and games. Classes will consist of guided instruction with an instructor via Google Meet, and free coding time with the instructor available for questions.',
    capacity: 7,
    courseType: 'youth'
  },
  web_dev_beginner: {
    id: 'web_dev_beginner',
    name: 'Intro to Web Development (Beginner)',
    minAge: 10,
    maxAge: 12,
    skillLevel: 'Beginner - Intermediate',
    description:
      'This course is designed for students who have never coded before. Students will be introduced to fundamental coding concepts through web development. Students will use HTML and CSS to create a variety of simple websites. Classes will consist of guided instruction with an instructor via Google Meet, and free coding time with the instructor available for questions.',
    capacity: 5,
    courseType: 'youth'
  },
  web_dev_intermediate: {
    id: 'web_dev_intermediate',
    name: 'Intro to Web Development (Intermediate)',
    minAge: 13,
    maxAge: 18,
    skillLevel: 'Beginner - Intermediate',
    description:
      'This course is designed for students who have some experience coding. Students will practice their coding skills and dive deeper into web development. Students will use HTML, CSS and JavaScript to create interactive and responsive websites. Classes will consist of guided instruction with an instructor via Google Meet, and free coding time with the instructor available for questions.',
    capacity: 10,
    courseType: 'youth'
  },
  python: {
    id: 'python',
    name: 'Python Programming',
    minAge: 13,
    maxAge: 18,
    skillLevel: 'Beginner - Advanced',
    description:
      'This course is designed for students who have any degree of coding experience. Students will learn fundamental coding concepts, and practice good coding form while creating animations and games. Students will use Python turtles to create drawings, animations and games. Classes will consist of guided instruction with an instructor via Google Meet, and free coding time with the instructor available for questions.',
    capacity: 10,
    courseType: 'youth'
  },
  next_level: {
    id: 'next_level',
    name: 'Next Level Coding',
    minAge: 13,
    maxAge: 18,
    skillLevel: 'Advanced',
    description:
      'This course is designed for students who have significant coding experience.  Students will work on individual passion projects and ideas with the help of an instructor. Students will further develop the coding skills they already have, and be more prepared for jobs in the world of computing. Classes will consist of project planning, mentoring, coding, mini-lessons, and Q&A with an instructor via Google Meet.',
    capacity: 10,
    courseType: 'youth'
  },
  arcade: {
    id: 'arcade',
    name: 'Arcade Game Design',
    minAge: 13,
    maxAge: 18,
    skillLevel: 'Beginner - Advance',
    description: "Teens build classic arcade games from start to finish that can be played over and over again.",
    capacity: 10,
    courseType: 'youth'
  },
  intro_coding_careers: {
    id: 'intro_coding_careers',
    name: 'Intro to Careers and Coding',
    skillLevel: 'Beginner',
    description: 'Intro to Careers and Coding is an entry-level coding program for adult learners (ages 18 and older). In each session, participants receive hands-on experience working with computer science technologies and an understanding of technology careers.',
    capacity: 20,
    courseType: 'adult'
  }
}
